import type { VoteEntity } from "@/appInterface/windows/VoteWindow/VoteResults/types";
import type {
    CreateOrDeleteVoteProperty,
    PropertyBuildEventAction,
    PropertyBuildEventStructure,
    PropertyEventStructure,
} from "@/eventManager/events/types";

export const getVoteStats = (
    voteInfo: VoteEntity,
    myUserToken: string,
): { myVoteCount: number; totalCandidates: number } => {
    let myVoteCount = 0;

    for (const child of Object.values(voteInfo.children)) {
        child.votes.forEach((vote) => {
            if (vote.token === myUserToken) {
                myVoteCount += 1;
            }
        });
    }

    const totalCandidates = Object.keys(voteInfo.children).length;

    return { myVoteCount, totalCandidates };
};

export const getFinishEventData = (UID: string): PropertyEventStructure[] => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "status",
            state: {
                isResolved: true,
            },
        },
    ];
};

export const getAddDurationEventData = (
    UID: string,
    duration: number,
): PropertyEventStructure[] => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "status",
            state: {
                additionalDuration: duration,
            },
        },
    ];
};

export const getAddOrRemoveVoteEventData = (
    UID: string,
    widgetUID: string,
    action: PropertyBuildEventAction,
    userToken: string,
    accountName: string,
): PropertyBuildEventStructure[] => {
    const property: CreateOrDeleteVoteProperty = { childUID: widgetUID, token: userToken };

    if (action === "add") {
        property.accountName = accountName;
    }

    return [
        {
            type: "propertyBuild",
            UID,
            fixType: "votes",
            action,
            property,
        },
    ];
};
